import { useMutation } from '@tanstack/react-query';
import { commonService } from '@/query/services/commonService';

export const useUploadFile = (options) => {
  return useMutation({
    mutationFn: ({ file, onProgress } = {}) =>
      commonService.uploadFile(file, onProgress),
    ...options,
  });
};
